export enum StatusEnum {
  Idle,
  Loading,
  Succeeded,
  Failed,
}
